import * as React from "react";
import { useWebSocket } from "../useWebSocket";

/** Ignore websocket revision bumps briefly after a local training save (echo suppression). */
let suppressRemoteRevisionUntil = 0;

/** Call before/after local training writes so our own WS echo does not soft-refresh mid-save. */
export function suppressCertificationModuleRemoteRevision(ms = 2500) {
  suppressRemoteRevisionUntil = Date.now() + ms;
}

/**
 * Bumps when another client updates this certification module or its trainings
 * (`entity:certification-modules:{moduleId}`). Used to soft-refresh module shell
 * fields (hero image) and quiz structure that localization events do not cover.
 */
export function useCertificationModuleRemoteRevision(moduleId: string | null | undefined) {
  const { subscribe, unsubscribe } = useWebSocket();
  const [trainingRemoteRevision, setTrainingRemoteRevision] = React.useState(0);

  React.useEffect(() => {
    if (!moduleId) return;
    const topic = `entity:certification-modules:${moduleId}`;
    const handler = () => {
      if (Date.now() < suppressRemoteRevisionUntil) return;
      setTrainingRemoteRevision((n) => n + 1);
    };
    subscribe([topic], handler);
    return () => unsubscribe([topic], handler);
  }, [moduleId, subscribe, unsubscribe]);

  return trainingRemoteRevision;
}
